/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './trigger-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-trigger-list-page',
  template
})
export class TriggerListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.dat-seg.triggers.trigger';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {label: 'folders', param: '', sortable: false},
    {label: 'addSegment', param: '', sortable: false},
    {label: 'removeSegment', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
